














































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Banner} from '@/model/resource/Banner'
import {BannerCollection} from '@/model/collection/BannerCollection'
import {ListBannerSchema} from '@/schema/resource/Banner/ListBannerSchema'
import {CsvBannerSchema} from '@/schema/resource/Banner/CsvBannerSchema'

@Component
export default class ListBannerView extends Mixins(MixinQueryRouter) {
  schema = new ListBannerSchema()
  collection = new BannerCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Banner) {
    Helper.pushByName('editBanner', item.$id)
  }

  async removeItem(item: Banner) {
    await new DialogRemove(item).confirm(() => item.removeBanner())
    await this.collection.listBanner()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new BannerCollection().clearFilters().addFilter(params)

    await csv.listCsvBanner()
    new CsvBannerSchema().downloadCsv(csv.all())
  }
}
